import { DEMO_STATE, readDemoState } from "./demoState";

export type SortDirection = "asc" | "desc";

export type PageQuery<TFilters = Record<string, unknown>> = {
	page: number;
	pageSize: number;
	search?: string;
	filters?: TFilters;
	sort?: { field: string; direction: SortDirection };
};

export type PagedResult<TItem> = {
	items: TItem[];
	total: number;
	page: number;
	pageSize: number;
};

export const DEFAULT_PAGE_SIZE = 10;

// One sample REG for Beranda, Akun, Lengkapi Data, and Kontrak.
export const SAMPLE_REGISTRATION_NUMBER = "REG/261103/482911";

export const SAMPLE_ERROR_MESSAGE = "Data belum bisa dimuat. Coba lagi.";

const SAMPLE_RESPONSE_DELAY_MS = 350;
const SAMPLE_LOADING_DELAY_MS = 600_000;
const UPLOAD_TICK_MS = 350;
const UPLOAD_MINIMUM_STEP_PERCENT = 4;
const UPLOAD_RANDOM_STEP_PERCENT = 10;
const COMPLETE_PERCENT = 100;

const wait = (milliseconds: number) =>
	new Promise<void>((resolve) => setTimeout(resolve, milliseconds));

// Simulates network per demo state.
export async function resolveSample<TValue>(
	value: TValue,
	emptyValue: TValue,
): Promise<TValue> {
	const demoState = readDemoState();
	if (demoState === DEMO_STATE.Loading) await wait(SAMPLE_LOADING_DELAY_MS);
	await wait(SAMPLE_RESPONSE_DELAY_MS);
	if (demoState === DEMO_STATE.Error) throw new Error(SAMPLE_ERROR_MESSAGE);
	return demoState === DEMO_STATE.Empty ? emptyValue : value;
}

export function paginateSample<TItem>(
	items: TItem[],
	query: PageQuery,
): Promise<PagedResult<TItem>> {
	const start = (query.page - 1) * query.pageSize;
	const page = {
		items: items.slice(start, start + query.pageSize),
		total: items.length,
		page: query.page,
		pageSize: query.pageSize,
	};
	return resolveSample(page, { ...page, items: [], total: 0 });
}

export function matchesSearch(
	search: string | undefined,
	...values: (string | undefined | null)[]
): boolean {
	const keyword = search?.trim().toLowerCase();
	if (!keyword) return true;
	return values.some((value) => value?.toLowerCase().includes(keyword));
}

// Simulated upload progress.
export async function simulateSampleUpload(
	_file: Blob,
	onProgress: (percent: number) => void,
): Promise<void> {
	let percent = 0;
	while (percent < COMPLETE_PERCENT) {
		await wait(UPLOAD_TICK_MS);
		percent = Math.min(
			COMPLETE_PERCENT,
			percent +
				UPLOAD_MINIMUM_STEP_PERCENT +
				Math.random() * UPLOAD_RANDOM_STEP_PERCENT,
		);
		onProgress(percent);
	}
}
